export default {
  bad_connection: '不好意思，发生了不明错误。请查看您的网络连接，然后再试一次。',
  send: '发送',
  select_hotel: 'Please select the hotel you are staying',
  select_language: '请选择您的语言。',
  start_chatting: 'Start Chatting',
  languages: '语言',
  menu: '选单',
  close: '关闭',
  back: '上一步',
  next: '下一步',
  message: '请以完整句子输入您的问题',
  search: '开始搜寻',
  select: '选择',
  sign_in: '登录',
  sign_out: '退出',
  sign_up: '注册',
  smoking: '吸烟',
  no_smoking: '禁烟',
  adults: '成人',
  xAdults: '成人',
  children: '儿童',
  ageOfChild: '儿童的年齢',
  seeAll: '显示全部',
  email: '邮箱',
  email_confirmation: '邮箱 (确认用)',
  phone_number: '住客电话',
  icc: 'ICC',
  month: '月',
  year: '年',
  including_taxes: '含稅',
  excluding_taxes: '不含税',
  show_more: '显示更多',
  show_less: '显示较少',
  file_upload: {
    unsupported_file_type: '非常抱歉，我们不支持{file_type}格式的文件。',
    file_size_exceeded: '文件超过大小的限制10mb',
    file_upload_failed: '文件上传失败',
    max_files_upload_simultaneously: '最多可同时上传5份文件'
  },
  base: {
    back_to_list: '返回目录',
    pay: '支付',
    cancel: '取消',
    delete: '删除',
    yes: '是',
    no: '不是',
    book: '预约',
    direct_price: '直销价格',
    membership_rate: '会员价格',
    regular_rate: '标准价格',
    expand_for_price: '展开以比较',
    confirmSelection: '确认选择',
    neverAskAgain: '不再显示',
    accept: '同意',
    do_not_accept: '不同意',
    password: '密码',
    email: '电子邮箱',
    save: '保存',
    confirm_password: '确认密码',
    error02: '不好意思,处理过程时系统发生错误, 请稍后再试。',
    errorCode: {
      3001: '发生超时错误。支付尚未处理。',
      3002: '支付处理失败。',
      3003: '此信用卡无法使用。',
      3004: '请确认信用卡卡号。',
      3005: '请确认有效日期是否正确。',
      3006: '3D验证失败。',
      3007: '信用卡输入错误或无法使用。',
      3008: '3D验证已被取消。',
      3009: '因多方要求，我们已经暂停3D验证。',
      3011: '发生超时错误。支付尚未处理。',
      3203: '不好意思,处理过程时系统发生错误, 请稍后再试。',
      3204: '付款过程失败，请使用其他卡，或稍后重试。',
      3205: '此信用卡无法使用。'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: '请检查你输入的信息',
    INVALID_EXPIRATION_YEAR: '请确认有效日期是否正确。',
    Invalid_card_number: '请确认信用卡卡号。',
    Others: '请检查你输入的信息'
  },
  validation: {
    is_required: '{field}是必填的',
    correct_email: '请输入正确的电子邮箱',
    invalid_integer: '请输入一个整数。'
  },
  chat_body: {
    deleted_message: '您已经删除此信息',
    op_deleted_msg: '人工客服删除此信息',
    delete_message: '删除信息',
    delete_message_desc: '您确定想要删除此信息吗？请注意删除后无法再复原'
  },
  user_top: {
    information:
      '如您想在其他设备上继续与我们对话，可以立即注册，这样您就可以在其他设备上登录后查看到与我们的对话记录。',
    terms_and_condition: {
      before: '已同意',
      link: '使用协议与条款',
      and: '和',
      privacy_policy: '隐私权政策',
      after: '。'
    },
    sign_in_with_facebook: '用Facebook登录',
    sign_out_with_facebook: '在此设备退出Facebook账号',
    sign_in_with_line: '用LINE登录',
    sign_in_with_weibo: '用Weibo登录',
    create_account: '开设账号',
    or: '或者',
    already_have_an_account: '已有账号？',
    sign_in_with_email: '用邮箱登录',
    forgot_password: '忘记密码？'
  },
  new_user: {
    information: '请输入您的姓名与邮箱，再点击“注册”',
    information2: '您将会收到一封来自chatbot@tripla.jp的邮件',
    first_name: '名字',
    last_name: '姓氏',
    name_placeholder: '姓名',
    email_placeholder: '邮箱',
    submit: '注册',
    email_sent:
      'A verification link has been sent to your email account. Please click on the link that has just been sent and {sign in}',
    error_message: {
      problem:
        'There was a problem creating your account. Please check your email address and try again.',
      email: '邮箱无效或已注册'
    }
  },
  new_session: {
    information: '请输入您的邮箱和密码，然后点击“登录”',
    email_placeholder: '邮箱',
    password_placeholder: '密码',
    submit: '登录/登录会员',
    error_message: {
      email: '很抱歉，您输入的邮箱或密码错误',
      known_user_different: 'The known user is different'
    }
  },
  destroy_session: {
    information: '您希望退出吗？ 如果您想要显示对话记录，您需要再次登录',
    submit: '退出'
  },
  forgotten_password: {
    information: '请输入您的邮箱。我们会发送确认邮件到您的邮箱。',
    email_placeholder: '邮箱',
    submit: '发送',
    error: 'Unable to reset password'
  },
  forgotten_password_confirmation: {
    information: '几分钟后您将会收到一封邮件。我们会通过邮件向您说明如何重设密码。'
  },
  reset_password: {
    title: '更改密码',
    password_title: '密码',
    password_hint: '至少8位数字，字母，常用符号',
    password_confirmation_title: '密码（确定）',
    submit: '更改密码'
  },
  set_reset_password: {
    title: '更改密码',
    information: '您的密码已经被重设。',
    information2: '请回到登录页面重新登录。'
  },
  menu_items: {
    1: '查看空房',
    2: '预订房间',
    3: '确认预约'
  },
  modal: {
    back_to_chat: '返回聊天视窗'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'Mastercard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Diners Club'
  },
  credit_card: {
    error: {
      cvv: '请确认您的CVV（安全码）是否正确。',
      expiration: '请确认有效日期是否正确。',
      name: '请确认信用卡持卡人的姓名是否正确。',
      number: '请使用有效的信用卡。',
      unknown: '您的申请过程出现了问题，请确定输入信息是否正确。',
      reservation_month:
        '请确定您输入的信用卡的有效期限在您的预约当月以后。（例：若您的预约在8月，信用卡的有效期间需在8月以后）'
    },
    accept: '我们接受：',
    cvv: 'CVV（安全码）',
    expiration: '有效日期',
    intro: '请输入以下信用卡信息：',
    name: '持卡人姓名',
    number: '信用卡卡号',
    save: '保存这张信用卡',
    submit: '新增信用卡',
    title: '新增新的信用卡',
    security_code: '安全码（CVV)',
    card_holder_confirm: '请确认信用卡持有者姓名',
    card_holder_format_confirm: '请用拼音字母输入姓名。',
    expiration_confirm: '请确认信用卡有效期限',
    card_cvv_confirm: '请确认输入的安全码',
    card_number_confirm: '请确认信用卡卡号',
    card_brand: '信用卡组织',
    select_card_brand: '请选择信用卡组织'
  },
  payment: {
    total: '总额'
  },
  currencies: {
    JPY: '日元'
  },
  chat_channels: {
    title: '请选择频道',
    facebook: 'Messenger',
    web: 'Web',
    line: 'LINE',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: '申请一覧',
    request: '申请',
    status: '状态',
    no_data: '目前没有请求',
    payment: '支付',
    customer: '顾客',
    phone: '电话号码',
    people: '人数',
    facility_name: '设施名称',
    requested_day: '希望日期',
    requested_time: '希望时间',
    confirm_cancel_msg:
      '请确认希望取消此项申请。我们将向管理员发送通知。取消完成后，您将收到有关的结果通知。',
    cancel_request: '取消申请',
    edit_request: '修改申请',
    keep_request: '保留申请'
  },
  requests: {
    statuses: {
      _destroyed: '消除',
      cancel_requested: '要求取消',
      cancelled: '取消',
      change_requested: '变更中',
      created: '要处理',
      departure_unconfirmed: '出发尚未确认',
      done: '完成',
      in_progress: '确认中',
      no_show: '没有出现',
      stopped: '中止出发',
      wait_listed: '候补',
      waiting_detail: '详情等候中'
    }
  },
  best_rate: '最优惠价格',
  time_picker: {
    AM: '上午',
    PM: '下午'
  },
  details_page: {
    details: '查看详细内容'
  },
  date_range: {
    select: '选择您入住的日期',
    send: '点击“选择”以继续',
    no_disabled_dates: '您选择的住宿日期已经没有空房，建议您选择其他的日期。'
  },
  facebook: {
    email_sent: '我们已将确认链接发送至您的邮箱，请点击链接确认预约。',
    no_email: '请输入您的邮箱地址。当预约完成后，我们会发送预约确认邮件至您的邮箱。',
    signInFailed: '登录失败。请再试一次。',
    sign_out: '请点击此按钮，退出Facebook账号。'
  },
  confirm_form: {
    search: '重新搜索客房',
    update_contact: '修改联系资料'
  },
  contact_form: {
    update: '更新',
    submit: '提交',
    full_name: '姓名（拼音）',
    family_name: '姓',
    first_name: '名字',
    cc_email: '发送邮件副本给...',
    error: {
      full_name_error: '请输入姓名的拼音。',
      tel_format_error: '电话的输入可接受数字，空格，（），＋等。',
      tel_length_error: '电话号码需为9个数字以上。',
      email_format_error: '请提供正确的电子邮箱。（例：name@gmail.com）',
      email_confirmation_error: 'email addresses not identical'
    }
  },
  room_not_available: '非常抱歉，根据您选择的房型，我们目前没有合适的方案，请重新搜索。',
  search_again: '重新搜索客房',
  room_not_available_short: '无法使用',
  email_form: {
    note_placeholder: '请输入洽询的详情。'
  },
  rental_car_form: {
    pickup_title: '取车店铺',
    pickup_area: '选择区域',
    pickup_shop: '选择店铺',
    pickup_date_time: '取车日期及时间',
    return_title: '还车店铺',
    return_area: '选择区域',
    return_shop: '选择店铺',
    return_date_time: '还车日期及时间',
    back: '返回'
  },
  search_area_form: {
    select_prefecture_area: '请选择省份及区域',
    prefecture: '省份',
    area: '区域'
  },
  restaurant_form: {
    breakfast: '早餐',
    lunch: '午餐',
    dinner: '晚餐',
    main_time: '希望开始时间',
    alternative_times: '其他候选时间',
    pick_multiple: '建议选择3个开始时间',
    any_available_time: '任何时间皆可'
  },
  terms_of_use: '使用条款',
  privacy_policy: '隐私条款',
  browser_warning:
    '您的网页浏览器不是最新版本。请更新浏览器版本，以便获得更安全，更快速和最佳的体验。',
  for_night: '住宿{n}晚',
  chat_icon: {
    chat: '聊天视窗'
  },
  chat_evaluation: {
    title: '客户满意度',
    msg: '请问您对我们的聊天机器人满意吗?',
    not_satisfied: '不满意',
    satisfied: '满意'
  },
  cookie_consent: {
    title: '管理Cookie政策',
    necessary: '必须同意: 聊天记录和登入状态',
    functional: '功能: Cookie将保存隐私政策和聊天机器人的设定。',
    performance: '性能: Cookie将计算访问次数和用户点击次数，从以帮助我们改善服务。',
    advertising: '目标和广告: Cookie使广告信息与您相关。',
    accept_all: '全部接受',
    confirm: '确认我的选择',
    cookies_accepted: '接受Cookies'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
